const HomePageShimmer = () => {
  return (
    <>
      <div className="shimmerCard">
        <div className="shimmerCardImg shine"></div>
        <div className="shimmerCardDesc">
          <div className="shimmerLines shine"></div>
          <div className="shimmerLines shine"></div>
          <div className="shimmerLines shine"></div>
        </div>
      </div>
      <div className="shimmerCard">
        <div className="shimmerCardImg shine"></div>
        <div className="shimmerCardDesc">
          <div className="shimmerLines shine"></div>
          <div className="shimmerLines shine"></div>
          <div className="shimmerLines shine"></div>
        </div>
      </div>
      <div className="shimmerCard">
        <div className="shimmerCardImg shine"></div>
        <div className="shimmerCardDesc">
          <div className="shimmerLines shine"></div>
          <div className="shimmerLines shine"></div>
          <div className="shimmerLines shine"></div>
        </div>
      </div>
      <div className="shimmerCard">
        <div className="shimmerCardImg shine"></div>
        <div className="shimmerCardDesc">
          <div className="shimmerLines shine"></div>
          <div className="shimmerLines shine"></div>
          <div className="shimmerLines shine"></div>
        </div>
      </div>
      <div className="shimmerCard">
        <div className="shimmerCardImg shine"></div>
        <div className="shimmerCardDesc">
          <div className="shimmerLines shine"></div>
          <div className="shimmerLines shine"></div>
          <div className="shimmerLines shine"></div>
        </div>
      </div>
      <div className="shimmerCard">
        <div className="shimmerCardImg shine"></div>
        <div className="shimmerCardDesc">
          <div className="shimmerLines shine"></div>
          <div className="shimmerLines shine"></div>
          <div className="shimmerLines shine"></div>
        </div>
      </div>
      <div className="shimmerCard">
        <div className="shimmerCardImg shine"></div>
        <div className="shimmerCardDesc">
          <div className="shimmerLines shine"></div>
          <div className="shimmerLines shine"></div>
          <div className="shimmerLines shine"></div>
        </div>
      </div>
      <div className="shimmerCard">
        <div className="shimmerCardImg shine"></div>
        <div className="shimmerCardDesc">
          <div className="shimmerLines shine"></div>
          <div className="shimmerLines shine"></div>
          <div className="shimmerLines shine"></div>
        </div>
      </div>
      <div className="shimmerCard">
        <div className="shimmerCardImg shine"></div>
        <div className="shimmerCardDesc">
          <div className="shimmerLines shine"></div>
          <div className="shimmerLines shine"></div>
          <div className="shimmerLines shine"></div>
        </div>
      </div>
      <div className="shimmerCard">
        <div className="shimmerCardImg shine"></div>
        <div className="shimmerCardDesc">
          <div className="shimmerLines shine"></div>
          <div className="shimmerLines shine"></div>
          <div className="shimmerLines shine"></div>
        </div>
      </div>
      <div className="shimmerCard">
        <div className="shimmerCardImg shine"></div>
        <div className="shimmerCardDesc">
          <div className="shimmerLines shine"></div>
          <div className="shimmerLines shine"></div>
          <div className="shimmerLines shine"></div>
        </div>
      </div>
      <div className="shimmerCard">
        <div className="shimmerCardImg shine"></div>
        <div className="shimmerCardDesc">
          <div className="shimmerLines shine"></div>
          <div className="shimmerLines shine"></div>
          <div className="shimmerLines shine"></div>
        </div>
      </div>
      <div className="shimmerCard">
        <div className="shimmerCardImg shine"></div>
        <div className="shimmerCardDesc">
          <div className="shimmerLines shine"></div>
          <div className="shimmerLines shine"></div>
          <div className="shimmerLines shine"></div>
        </div>
      </div>
      <div className="shimmerCard">
        <div className="shimmerCardImg shine"></div>
        <div className="shimmerCardDesc">
          <div className="shimmerLines shine"></div>
          <div className="shimmerLines shine"></div>
          <div className="shimmerLines shine"></div>
        </div>
      </div>
      <div className="shimmerCard">
        <div className="shimmerCardImg shine"></div>
        <div className="shimmerCardDesc">
          <div className="shimmerLines shine"></div>
          <div className="shimmerLines shine"></div>
          <div className="shimmerLines shine"></div>
        </div>
      </div>
      <div className="shimmerCard">
        <div className="shimmerCardImg shine"></div>
        <div className="shimmerCardDesc">
          <div className="shimmerLines shine"></div>
          <div className="shimmerLines shine"></div>
          <div className="shimmerLines shine"></div>
        </div>
      </div>
      <div className="shimmerCard">
        <div className="shimmerCardImg shine"></div>
        <div className="shimmerCardDesc">
          <div className="shimmerLines shine"></div>
          <div className="shimmerLines shine"></div>
          <div className="shimmerLines shine"></div>
        </div>
      </div>
      <div className="shimmerCard">
        <div className="shimmerCardImg shine"></div>
        <div className="shimmerCardDesc">
          <div className="shimmerLines shine"></div>
          <div className="shimmerLines shine"></div>
          <div className="shimmerLines shine"></div>
        </div>
      </div>
    </>
  );
};
export default HomePageShimmer;
